import React, { useEffect, createElement, Component } from 'react';
import { Clock, Check, CheckCircle, Truck, ShieldCheck, ThumbsUp, BadgeCheck, MessageCircle, ChevronRight, Droplets, Activity, Leaf } from 'lucide-react';
// Datos de los comentarios estilo Facebook
const commentsData = [{
  id: 1,
  name: 'Begoña Alcalá',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/bYki87VQaRVxYf4jX3bKTH/13.jpg',
  text: 'alguien lo ha probado de verdad??',
  likes: 8,
  time: 'hace 14 min',
  replies: [{
    id: 11,
    name: 'Trini Monreal',
    verified: false,
    avatar: 'https://cdn.magicpatterns.com/uploads/h1eXJjEnyQgh7knHHMA6wY/Captura_de_pantalla_2026-04-23_a_las_10.35.12.png',
    text: 'Yo Begoña, 3 semanas y las piernas ni las reconozco 🙌',
    image: 'https://cdn.magicpatterns.com/uploads/76YtcV9WajSWmyPtE7EvZQ/Captura_de_pantalla_2026-04-23_a_las_10.41.47.png',
    likes: 12,
    time: 'hace 9 min'
  }]
}, {
  id: 2,
  name: 'Juani Ramírez',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/7ZPYeMbzHkXYhTJReeshy4/20.jpg',
  text: 'Me lo compré en mayo y sigo tomándolo. No falla 👌',
  likes: 6,
  time: 'hace 22 min'
}, {
  id: 4,
  name: 'Mila Ochoa',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/fc4g3HBghwwcrpVPxb7T15/3_1.jpg',
  text: 'llevo 2 semanas y ya me entran los anillos otra vez 😭😭',
  likes: 18,
  time: 'hace 48 min'
}, {
  id: 5,
  name: 'Remedios T.',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/btBYJTLSLJj8iJBxXEiwWS/7.jpg',
  text: 'cuanto tarda en llegar?',
  likes: 2,
  time: 'hace 1 h',
  replies: [{
    id: 51,
    name: 'Chelo Vargas',
    verified: false,
    avatar: 'https://cdn.magicpatterns.com/uploads/grEeJXbDCxGiu1XggoUoNb/Captura_de_pantalla_2026-04-23_a_las_10.35.06.png',
    text: 'a mi 2 dias reme',
    likes: 5,
    time: 'hace 52 min'
  }]
}, {
  id: 6,
  name: 'Encarni L.',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/oPgLoogsxgV4M6tQYh9Uxw/Captura_de_pantalla_2026-04-23_a_las_9.20.36.png',
  text: 'Con la menopausia el médico solo me daba Seguril. Llevo mes y medio con esto y otra persona soy.',
  likes: 21,
  time: 'hace 1 h'
}, {
  id: 7,
  name: 'Maribel Cortés',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/xfiYVksm5h3Mz7njMhuuR2/Captura_de_pantalla_2026-04-23_a_las_9.20.25.png',
  text: 'que rabia lo compré hace un mes al precio normal 😤',
  likes: 7,
  time: 'hace 2 h'
}, {
  id: 8,
  name: 'Loli F.',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/vgwHZyMLZjmnMSnz9PsqVg/Captura_de_pantalla_2026-04-23_a_las_9.20.16.png',
  text: 'mi hija me ha dicho mama q te pasa en las piernas jajaj le he tenido que contar',
  likes: 14,
  time: 'hace 2 h'
}, {
  id: 9,
  name: 'Tere Hidalgo',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/1rTxX9Cu5BVtBh97kHPNmU/Captura_de_pantalla_2026-04-23_a_las_9.20.01.png',
  text: '8h de pie en la peluquería y llegaba llorando. Ahora aguanto el día entero 🙏',
  image: 'https://cdn.magicpatterns.com/uploads/jdezN3YeHqYvXCPjDoSAui/Captura_de_pantalla_2026-04-23_a_las_10.43.13.png',
  likes: 11,
  time: 'hace 2 h'
}, {
  id: 10,
  name: 'Rocío Peinado',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/1746ug2q65cHVkddgFioLn/Captura_de_pantalla_2026-04-23_a_las_9.19.55.png',
  text: 'se puede tomar con pastillas para la tension?',
  likes: 1,
  time: 'hace 3 h',
  replies: [{
    id: 101,
    name: 'Puri Galán',
    verified: false,
    avatar: 'https://cdn.magicpatterns.com/uploads/9D8fGSdPeV9bnUV3CKpeyV/Captura_de_pantalla_2026-04-23_a_las_10.37.29.png',
    text: 'Rocío consulta con tu medico, yo tomo sintrom y me dijo q si',
    likes: 3,
    time: 'hace 2 h'
  }]
}, {
  id: 12,
  name: 'Nieves Aranda',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/r8agqMkB2x7TdRCpvCURtp/Captura_de_pantalla_2026-04-23_a_las_10.35.39.png',
  text: 'en Sevilla en agosto era imposible ponerme sandalias. este año veremos 🤞',
  likes: 9,
  time: 'hace 3 h'
}, {
  id: 14,
  name: 'Marga B.',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/p7hcr4utKPUsSX4K7b1d2K/Captura_de_pantalla_2026-04-23_a_las_10.35.29.png',
  text: 'acabo de pedirlo, cruzando los dedos',
  likes: 6,
  time: 'hace 4 h'
}, {
  id: 15,
  name: 'Asun P.',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/55GFXMGfdSCii7E9a9uRos/Captura_de_pantalla_2026-04-23_a_las_10.35.20.png',
  text: 'hija mía esto es oro 😍',
  likes: 8,
  time: 'hace 5 h'
}];
// Utilidad para obtener iniciales
const getInitials = (name: string) => {
  return name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
};
// Componente de Comentario Individual
const Comment = ({
  comment,
  isReply = false
}: {
  comment: any;
  isReply?: boolean;
}) => <div className={`flex gap-2 ${isReply ? 'mt-3' : 'mt-4'}`} data-id="element-0">
    <div className="flex-shrink-0" data-id="element-1">
      {comment.avatar ? <img src={comment.avatar} alt={comment.name} className="w-10 h-10 rounded-full object-cover" data-id="element-2" /> : <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-bold text-sm" data-id="element-3">
          {getInitials(comment.name)}
        </div>}
    </div>
    <div className="flex-1" data-id="element-4">
      <div className="bg-[#f0f2f5] rounded-2xl px-3 py-2 inline-block max-w-full" data-id="element-5">
        <div className="flex items-center flex-wrap gap-1 mb-1" data-id="element-6">
          <span className="font-bold text-[15px] text-[#050505] hover:underline cursor-pointer" data-id="element-7">
            {comment.name}
          </span>
          {comment.verified && <span className="flex items-center text-[#1877F2] text-[13px] font-medium ml-1" data-id="element-8">
              <BadgeCheck size={14} className="mr-1" fill="currentColor" stroke="white" data-id="element-9" />
              Compra verificada
            </span>}
        </div>
        <p className="text-[15px] text-[#050505] m-0 leading-snug" data-id="element-10">
          {comment.text}
        </p>
        {comment.image && <img src={comment.image} alt="Imagen adjunta" className="mt-2 max-w-[240px] w-full h-auto mx-auto block" data-id="element-11" />}
      </div>
      <div className="flex items-center gap-4 text-[13px] text-[#65676B] font-bold mt-1 ml-3" data-id="element-12">
        <button className="hover:underline" data-id="element-13">Me gusta</button>
        <button className="hover:underline" data-id="element-14">Responder</button>
        <span className="font-normal" data-id="element-15">{comment.time}</span>
        {comment.likes > 0 && <div className="flex items-center gap-1 bg-white shadow-sm border border-gray-100 rounded-full px-1.5 py-0.5 -ml-2 z-10 relative" data-id="element-16">
            <div className="bg-[#1877F2] rounded-full p-1" data-id="element-17">
              <ThumbsUp size={10} color="white" fill="white" data-id="element-18" />
            </div>
            <span className="text-[#65676B] font-normal" data-id="element-19">{comment.likes}</span>
          </div>}
      </div>

      {/* Respuestas anidadas */}
      {comment.replies && comment.replies.length > 0 && <div className="pl-2 border-l-2 border-gray-200 mt-2" data-id="element-20">
          {comment.replies.map((reply: any) => <Comment key={reply.id} comment={reply} isReply={true} data-id="element-21" />)}
        </div>}
    </div>
  </div>;
export function App() {
  // Meta Pixel
  useEffect(() => {
    ;
    (function (f: any, b, e, v, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        ;
        (b.head || b.documentElement).appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '992624086483436');
    (window as any).fbq('track', 'PageView');
    (window as any).fbq('trackCustom', 'ViewListicle', {
      content_name: 'Listicle Sonvital Drenaje',
      content_category: 'Article'
    });
  }, []);
  // Propaga parámetros de URL a los CTAs y dispara evento Lead al click
  useEffect(() => {
    const urlParams = window.location.search;
    const ctas = document.querySelectorAll<HTMLAnchorElement>('a.cta-pdp');
    const handlers: Array<{
      el: HTMLAnchorElement;
      fn: () => void;
    }> = [];
    ctas.forEach(link => {
      const href = link.getAttribute('href') || '';
      if (urlParams && urlParams.length > 1) {
        const separator = href.includes('?') ? '&' : '?';
        link.setAttribute('href', href + separator + urlParams.substring(1));
      }
      const fn = () => {
        if (typeof (window as any).fbq === 'function') {
          ;
          (window as any).fbq('track', 'Lead', {
            content_name: 'Click CTA Listicle to PDP',
            content_category: 'Listicle'
          });
        }
      };
      link.addEventListener('click', fn);
      handlers.push({
        el: link,
        fn
      });
    });
    return () => {
      handlers.forEach(({
        el,
        fn
      }) => el.removeEventListener('click', fn));
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-22">
      {/* Top Navigation Bar */}
      <nav className="border-b border-gray-200 bg-white sticky top-0 z-50 shadow-sm" data-id="element-23">
        <div className="max-w-4xl mx-auto px-4 h-16 flex items-center justify-between" data-id="element-24">
          <div className="font-serif text-2xl font-bold tracking-tight text-gray-900 flex items-center gap-2" data-id="element-25">
            <Leaf className="text-[#d4738c]" size={24} data-id="element-26" />
            Salud y Bienestar
          </div>
        </div>
      </nav>

      <main className="max-w-3xl mx-auto px-4 py-10 md:py-16" data-id="element-27">
        {/* Article Header */}
        <header className="mb-10" data-id="element-28">
          <div className="flex items-center gap-2 mb-6" data-id="element-29">
            <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-xs font-bold tracking-wider uppercase" data-id="element-30">
              Salud
            </span>
            <span className="text-gray-400 text-xs font-bold tracking-wider uppercase" data-id="element-31">
              |
            </span>
            <span className="text-[#d4738c] text-xs font-bold tracking-wider uppercase" data-id="element-32">
              SALUD MUJER
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl text-gray-900 leading-tight mb-6 font-[600]" data-id="element-33">
            Hoy Te Contamos Por Qué Tus Piernas Se Hinchan Cada Vez Más Y Cómo
            Solucionarlo
            <span className="block mt-4 md:text-3xl italic tracking-tight text-[27px] font-[400] text-[#000000]" data-id="element-34">
              (¡Dejar La Sal, Beber Agua o Hacer Dieta/Deporte{' '}
              <strong className="font-bold" data-id="element-35">No Es La Solución</strong>!)
            </span>
          </h1>

          <div className="flex items-center border-t border-b border-gray-100 py-4 mb-8" data-id="element-36">
            <div className="flex-shrink-0 mr-4" data-id="element-37">
              <img src="https://cdn.magicpatterns.com/uploads/jkvG73H29JNo8GE8tSJDnG/Gemini_Generated_Image_8esiag8esiag8esi.png" alt="Dra. Elena Ruiz" className="h-12 w-12 rounded-full object-cover" data-id="element-38" />
            </div>
            <div className="text-sm" data-id="element-39">
              <p className="font-bold text-gray-900 text-base" data-id="element-40">
                Por la Dra. Elena Ruiz
              </p>
              <p className="text-gray-600 m-0" data-id="element-41">Flebóloga · Madrid, España</p>
              <p className="text-gray-600 m-0" data-id="element-42">
                Miembro del Capítulo Español de Flebología y Linfología
              </p>
            </div>
          </div>
        </header>

        {/* Article Body */}
        <article className="article-body prose prose-lg prose-gray max-w-none prose-p:leading-[1.8]" data-id="element-43">
          <div className="bg-rose-50 p-6 rounded-2xl border border-rose-100 mb-10" data-id="element-44">
            <p className="font-bold text-gray-900 m-0" data-id="element-45">
              Si te despiertas con los tobillos hinchados, las piernas pesadas o
              una retención que empeora por la tarde, no eres la única.
            </p>
            <p className="font-bold text-gray-900 mt-4 mb-0" data-id="element-46">
              Soy la Dra. Elena Ruiz y en este artículo te explicaré las 5
              razones reales por las que la hinchazón vuelve una y otra vez y
              como solucionarlo de verdad.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-6 md:gap-8 items-start mt-12" data-id="element-47">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-0 flex items-start gap-3 mt-0 md:col-start-2 md:row-start-1" data-id="element-48">
              <span className="text-[#d4738c] font-black text-3xl md:text-4xl leading-none" data-id="element-49">
                1.
              </span>
              El Problema Real: Tu Sistema Linfático Está Atascado
            </h2>
            <figure className="w-full flex-shrink-0 m-0 md:row-span-2 md:row-start-1" data-id="element-50">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-51">
                <img src="https://cdn.magicpatterns.com/uploads/46XgoeArcWtdwe9xZfiWMa/Gemini_Generated_Image_mk0xwomk0xwomk0x.png" alt="Sistema linfático: vasos linfáticos, líquido atrapado, drenaje lento y acumulación de líquido" className="w-full h-auto object-contain" data-id="element-52" />
              </div>
            </figure>
            <div className="md:col-start-2" data-id="element-53">
              <p style={{
              marginBottom: '24px'
            }} data-id="element-54">
                La mayoría de mujeres piensan que tener los tobillos hinchados
                es por culpa de la sal o de estar mucho rato de pie.{' '}
                <strong data-id="element-55">No es así.</strong>
              </p>
              <p style={{
              marginBottom: '24px'
            }} data-id="element-56">
                En el 90% de los casos, lo que falla es el funcionamiento del
                sistema linfático — la red que drena el exceso de líquido de tus
                tejidos.
              </p>
              <p style={{
              marginBottom: '24px'
            }} data-id="element-57">
                Mientras ese líquido no se mueva, la hinchazón no se va. Da
                igual cuánta agua bebas o si haces dieta o deporte.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-6 md:gap-8 items-start mt-12" data-id="element-58">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-0 flex items-start gap-3 mt-0 md:col-start-2 md:row-start-1" data-id="element-59">
              <span className="text-[#d4738c] font-black text-3xl md:text-4xl leading-none" data-id="element-60">
                2.
              </span>
              Tu Sistema Linfático Se Vuelve Más Lento Con Los Años (Y La
              Menopausia Lo Empeora Drásticamente)
            </h2>
            <figure className="w-full flex-shrink-0 m-0 md:row-span-2 md:row-start-1" data-id="element-61">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-62">
                <img src="https://cdn.magicpatterns.com/uploads/3QqyRi2DwDhzxJqHU1z87X/Gemini_Generated_Image_hr54i7hr54i7hr54.png" alt="Gráfico mostrando el aumento de retención de líquidos con la edad" className="w-full h-auto object-contain" data-id="element-63" />
              </div>
            </figure>
            <div className="md:col-start-2" data-id="element-64">
              <p style={{
              marginBottom: '24px'
            }} data-id="element-65">
                Los estudios muestran que la función linfática se reduce hasta
                un 70% cada década a partir de los 40.
              </p>
              <p style={{
              marginBottom: '24px'
            }} data-id="element-66">
                En mujeres en menopausia, el proceso se acelera aún más por la
                caída de estrógenos.
              </p>
              <p style={{
              marginBottom: '24px'
            }} className="italic text-gray-600 border-l-4 border-gray-300 pl-4" data-id="element-67">
                Si le sumas el calor mediterráneo 6 meses al año, tienes la
                tormenta perfecta.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-6 md:gap-8 items-start mt-12" data-id="element-68">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-0 flex items-start gap-3 mt-0 md:col-start-2 md:row-start-1" data-id="element-69">
              <span className="text-[#d4738c] font-black text-3xl md:text-4xl leading-none" data-id="element-70">
                3.
              </span>
              El Líquido Atrapado En Tu Cuerpo No Tiene Por Dónde Salir
            </h2>
            <figure className="w-full flex-shrink-0 m-0 md:row-span-2 md:row-start-1" data-id="element-71">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-72">
                <img src="https://cdn.magicpatterns.com/uploads/h8eg5w1jbuENBqwzFTMDdU/1765884921-d157eca2-a098-4d30-bb10-30655b55bd13_(1).webp" alt="Mujer tocándose el tobillo hinchado sentada en el sofá" className="w-full h-auto object-contain" data-id="element-73" />
              </div>
            </figure>
            <div className="md:col-start-2" data-id="element-74">
              <p style={{
              marginBottom: '24px'
            }} data-id="element-75">
                Cuando el sistema linfático va lento, el líquido se queda
                estancado en los tejidos y por eso te hinchas.
              </p>
              <p style={{
              marginBottom: '24px'
            }} data-id="element-76">
                ¿Te suena esto? Zapatos que aprietan por la tarde, tobillos que
                ya no ves, las marcas del calcetín que no se van… Y aunque
                duermas 8 horas, te levantas igual de hinchada.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-6 md:gap-8 items-start mt-12" data-id="element-77">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-0 flex items-start gap-3 mt-0 md:col-start-2 md:row-start-1" data-id="element-78">
              <span className="text-[#d4738c] font-black text-3xl md:text-4xl leading-none" data-id="element-79">
                4.
              </span>
              Estás Tratando El Síntoma, No La Causa
            </h2>
            <figure className="w-full flex-shrink-0 m-0 md:row-span-2 md:row-start-1" data-id="element-80">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-81">
                <img src="https://cdn.magicpatterns.com/uploads/ommvMRrEki8ggZehzAACq4/Captura_de_pantalla_2026-04-23_a_las_8.10.00.png" alt="Piernas hinchadas por sistema linfático obstruido" className="w-full h-auto object-contain" data-id="element-82" />
              </div>
            </figure>
            <div className="md:col-start-2" data-id="element-83">
              <p style={{
              marginBottom: '24px'
            }} data-id="element-84">
                Tobillos hinchados, piernas pesadas, anillos que no entran,
                varices… todo eso son síntomas.
              </p>
              <p style={{
              marginBottom: '24px'
            }} className="font-bold text-xl text-gray-900" data-id="element-85">
                La causa real está en tus vasos linfáticos.
              </p>
              <p style={{
              marginBottom: '24px'
            }} data-id="element-86">
                Si solo tratas lo que se ve por fuera, nunca vas a solucionar lo
                que pasa por dentro.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-6 md:gap-8 items-start mt-12" data-id="element-87">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-0 flex items-start gap-3 mt-0 md:col-start-2 md:row-start-1" data-id="element-88">
              <span className="text-[#d4738c] font-black text-3xl md:text-4xl leading-none" data-id="element-89">
                5.
              </span>
              Las "Soluciones" De Siempre Solo Funcionan Mientras Las Usas
            </h2>
            <figure className="w-full flex-shrink-0 m-0 md:row-span-2 md:row-start-1" data-id="element-90">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-91">
                <img src="https://cdn.magicpatterns.com/uploads/gZzjojYRtgsk5cEH1U46FD/Captura_de_pantalla_2026-04-23_a_las_8.17.16.png" alt="Soluciones que no funcionan: pastillas diuréticas, medias de compresión, té detox, sales de baño tachadas con una X roja" className="w-full h-auto object-contain" data-id="element-92" />
              </div>
            </figure>
            <div className="md:col-start-2" data-id="element-93">
              <p style={{
              marginBottom: '24px'
            }} data-id="element-94">
                Seguril, medias de compresión, elevar las piernas, tés
                digestivos… ayudan en el momento. Pero no arreglan nada.
              </p>
              <p style={{
              marginBottom: '24px'
            }} data-id="element-95">
                Y ojo con los diuréticos: te deshidratan, te quitan potasio y
                provocan efecto rebote cuando los dejas.
              </p>
              <p style={{
              marginBottom: '24px'
            }} className="font-bold text-[#d4738c]" data-id="element-96">
                No estás solucionando el problema. Solo lo estás enmascarando.
              </p>
            </div>
          </div>

          {/* Solution Section */}
          <div className="mt-16 mb-12" data-id="element-97">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center" data-id="element-98">
              ¿Qué Funciona De Verdad?
            </h2>
            <p className="text-center text-xl mb-8" data-id="element-99">
              Para un alivio duradero, hay que ir a la raíz:
            </p>

            <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-200" data-id="element-100">
              <ul className="space-y-4 m-0 p-0 list-none" data-id="element-101">
                <li className="flex items-start gap-3" data-id="element-102">
                  <Check className="text-green-500 mt-1 shrink-0" size={24} data-id="element-103" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-104">
                    Despertar el sistema linfático dormido
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-105">
                  <Check className="text-green-500 mt-1 shrink-0" size={24} data-id="element-106" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-107">
                    Mover el líquido atrapado
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-108">
                  <Check className="text-green-500 mt-1 shrink-0" size={24} data-id="element-109" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-110">
                    Apoyar el drenaje desde dentro
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6" data-id="element-111">
            Lo Que Descubrí Cuando Una Paciente Me Dejó Sin Respuesta
          </h2>

          <p data-id="element-112">
            Durante años fui escéptica con los suplementos para la retención. En
            consulta había visto pasar de todo, y casi nada funcionaba. Por eso,
            cuando mis pacientes me preguntaban por alternativas a las medias y
            los diuréticos, siempre les daba la misma respuesta: drenaje manual
            semanal, elevación de piernas, y paciencia.
          </p>

          <p data-id="element-113">Hasta que llegó Maite.</p>

          <p data-id="element-114">
            Maite es paciente mía desde hace 6 años. 54 años, menopáusica, con
            una retención en tobillos que ningún tratamiento conseguía
            estabilizar. Un día entró en la consulta y no la reconocí. Sus
            piernas estaban distintas. Más definidas. Más ligeras. Le pregunté
            qué había cambiado y me dijo, casi avergonzada, que llevaba tres
            semanas tomando una fórmula botánica que había encontrado por su
            cuenta.
          </p>

          <p data-id="element-115">
            Me molestó. No por ella — por mí. Llevaba años recomendándole
            tratamientos caros y lentos, y resulta que una mezcla de plantas que
            yo nunca le había mencionado le había hecho más en 21 días que todo
            lo anterior junto.
          </p>

          <p data-id="element-116">
            Así que hice lo que tenía que hacer: me senté a estudiar la fórmula
            ingrediente por ingrediente. Iba con la idea de desmontarla.
            Esperaba encontrarme con lo de siempre — extractos a dosis
            ridículas, plantas de relleno, marketing vestido como ciencia.
          </p>

          <p data-id="element-117">No fue eso lo que encontré.</p>

          <h3 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-118">
            La planta que la fitoterapia moderna olvidó
          </h3>

          <p data-id="element-119">
            El componente que me hizo cambiar de opinión no era ninguno de los
            típicos drenantes que se ven en cualquier herbolario. Era una raíz
            que los médicos eclécticos americanos del siglo XIX usaban para
            tratar congestiones linfáticas crónicas:{' '}
            <strong data-id="element-120">la Raíz de Stillingia</strong>.
          </p>

          <p data-id="element-121">
            Lo que descubrí leyendo la literatura es que Stillingia no actúa
            sobre el líquido — actúa sobre los vasos linfáticos en sí.
            Concretamente, sobre los bloqueos profundos en los ganglios. Los que
            las medias de compresión y los diuréticos nunca alcanzan.
          </p>

          <p data-id="element-122">
            Es decir: mientras el resto de drenantes del mercado intentan
            empujar el líquido hacia fuera, Stillingia se ocupa de abrir el
            conducto por el que ese líquido tiene que salir. Sin esto, todo lo
            demás es trabajo perdido.
          </p>

          <p data-id="element-123">
            Por algún motivo, la fitoterapia moderna la dejó atrás. Hoy es
            prácticamente imposible encontrarla en suplementos europeos. Por eso
            ninguna de mis pacientes — ni yo misma — la conocíamos.
          </p>

          <h3 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-124">
            Pero Stillingia sola no es suficiente
          </h3>

          <p data-id="element-125">
            Aquí está lo que me terminó de convencer de la fórmula. La
            Stillingia abre los bloqueos, pero si los vasos linfáticos están
            dormidos, no sirve de nada destapar la salida. Y aunque consigas
            mover el líquido, si la microcirculación final está cerrada, todo se
            queda atrapado a un milímetro de salir.
          </p>

          <p data-id="element-126">
            Por eso la fórmula incluye otras tres plantas que cumplen funciones
            muy concretas:
          </p>

          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-200 my-8" data-id="element-127">
            <ul className="space-y-4 m-0 p-0 list-none" data-id="element-128">
              <li className="flex items-start gap-3" data-id="element-129">
                <Leaf className="text-[#d4738c] mt-1 shrink-0" size={24} data-id="element-130" />
                <div data-id="element-131">
                  <strong className="text-gray-900" data-id="element-132">Amor de Hortelano</strong> —
                  la planta que despierta los vasos linfáticos dormidos y los
                  pone a trabajar otra vez.
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-133">
                <Leaf className="text-[#d4738c] mt-1 shrink-0" size={24} data-id="element-134" />
                <div data-id="element-135">
                  <strong className="text-gray-900" data-id="element-136">
                    Corteza de Fresno Espinoso
                  </strong>{' '}
                  — reabre la microcirculación periférica, el último tramo del
                  recorrido por donde el líquido sale.
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-137">
                <Leaf className="text-[#d4738c] mt-1 shrink-0" size={24} data-id="element-138" />
                <div data-id="element-139">
                  <strong className="text-gray-900" data-id="element-140">Trébol Rojo</strong> —
                  específicamente para mujeres en menopausia: regula el
                  desajuste hormonal que acelera la retención a partir de los
                  45.
                </div>
              </li>
            </ul>
          </div>

          <p data-id="element-141">
            Y hay un detalle más, técnico pero importante: la fórmula está en
            extracto líquido, no en cápsula. Esto es bioquímica: Un extracto
            líquido se absorbe en mucosa oral y entra en circulación en minutos,
            mientras que una cápsula tiene que pasar por digestión completa y
            pierde gran parte del principio activo por el camino. Para plantas
            como Stillingia, que actúan a dosis bajas, esto marca la diferencia
            entre notar resultados o no notar nada.
          </p>

          <p data-id="element-142">
            Las cuatro plantas trabajan en secuencia, no en paralelo. Y la
            proporción exacta entre ellas es lo que hace que funcione. Si tomas
            Stillingia por separado, no notas nada. Si la combinas con las otras
            tres en las cantidades correctas y en el formato adecuado, entonces
            el sistema entero se activa.
          </p>

          <p data-id="element-143">
            Esa fórmula tiene un nombre comercial en España:{' '}
            <strong data-id="element-144">Sonvital™ — Drenaje Linfático</strong>.
          </p>

          <p data-id="element-145">
            Es lo que estaba tomando Maite. Y desde hace ya un año, es lo que
            recomiendo en mi consulta a cada paciente que entra por la puerta
            con el problema con el que Maite vino una vez.
          </p>

          <figure className="mt-8 mb-2 max-w-xs sm:max-w-sm mx-auto" data-id="element-146">
            <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-147">
              <img src="https://cdn.magicpatterns.com/uploads/jNqQ8tF8oV73ph87nupCdr/Captura_de_pantalla_2026-05-11_a_las_11.21.00.png" alt="Dra. Elena Ruiz en su consulta" className="w-full h-auto object-contain" data-id="element-148" />
            </div>
          </figure>

          <h2 className="text-3xl font-bold text-gray-900 mt-4 mb-6" data-id="element-149">
            Mi Conclusión:
          </h2>

          <p data-id="element-150">
            A mis pacientes siempre les digo lo mismo: la retención crónica no
            se soluciona con parches.
          </p>

          <p data-id="element-151">
            Si puedes permitirte un drenaje linfático manual semanal, adelante.
            Pero la mayoría no pueden gastarse 60€ cada semana.
          </p>

          <p data-id="element-152">
            Por eso, Drenaje Linfático de Sonvital es hoy la mejor relación
            calidad-precio del mercado español. Fórmula seria, fabricación
            europea y garantía de 60 días para probarlo sin riesgo.
          </p>

          <p data-id="element-153">
            No es un milagro. Ningún suplemento lo es. Pero los resultados que
            están reportando las mujeres son, sencillamente, impresionantes.
          </p>

          {/* Inline CTA */}
          <div className="my-10 text-center" data-id="element-154">
            <a href="https://sonvital.com/products/drenaje-linfatico" className="cta-pdp inline-flex items-center justify-center gap-2 bg-[#d4738c] hover:bg-[#b0556d] text-white text-lg md:text-xl font-bold py-4 px-8 md:px-10 rounded-full shadow-lg transform transition hover:scale-105 w-full md:w-auto no-underline" data-id="element-155">
              👉 Comprobar Disponibilidad — 50% DESCUENTO
            </a>
            <p className="text-sm text-gray-500 mt-3 flex items-center justify-center gap-2" data-id="element-156"></p>
          </div>

          {/* Product Section */}
          <div className="bg-white border-2 border-[#d4738c] rounded-3xl p-8 md:p-10 shadow-xl my-12 relative overflow-hidden" data-id="element-157">
            <div className="md:absolute md:top-0 md:right-0 inline-block bg-[#d4738c] text-white px-4 md:px-6 py-2 rounded-full md:rounded-bl-2xl md:rounded-full-none md:rounded-tr-none font-bold text-xs md:text-sm tracking-wider mb-4 md:mb-0" data-id="element-158">
              FÓRMULA 4 EN 1
            </div>

            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:pr-32" data-id="element-159">
              Esta Fórmula Actúa Sobre La Causa Real
            </h3>

            <figure className="my-8" data-id="element-160">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-161">
                <img src="https://cdn.magicpatterns.com/uploads/3n8fnopCQo3dtnVx25gpoD/Captura_de_pantalla_2026-04-23_a_las_8.58.52.png" alt="Antes y después: reducción de hinchazón en tobillos" className="w-full h-auto object-contain" data-id="element-162" />
              </div>
            </figure>

            <figure className="my-8" data-id="element-163">
              <img src="https://cdn.magicpatterns.com/uploads/9bqYiuvYnc4dRTtfc7ACym/Captura_de_pantalla_2026-05-09_a_las_19.30.34.png" alt="Sonvital — Drenaje Linfático" className="w-full max-w-md mx-auto h-auto object-contain" data-id="element-164" />
            </figure>

            <p className="text-lg mb-8" data-id="element-165">
              <strong data-id="element-166">Drenaje Linfático de Sonvital</strong> es una fórmula
              botánica que:
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-10" data-id="element-167">
              <div className="bg-rose-50 p-5 rounded-xl" data-id="element-168">
                <Activity className="text-[#d4738c] mb-3" size={32} data-id="element-169" />
                <p className="text-sm font-bold text-gray-900 m-0" data-id="element-170">
                  Activa los vasos linfáticos dormidos para que el líquido
                  vuelva a moverse
                </p>
              </div>
              <div className="bg-rose-50 p-5 rounded-xl" data-id="element-171">
                <Droplets className="text-[#d4738c] mb-3" size={32} data-id="element-172" />
                <p className="text-sm font-bold text-gray-900 m-0" data-id="element-173">
                  Disuelve la congestión de los ganglios para que el drenaje
                  fluya
                </p>
              </div>
              <div className="bg-rose-50 p-5 rounded-xl" data-id="element-174">
                <Activity className="text-[#d4738c] mb-3" size={32} data-id="element-175" />
                <p className="text-sm font-bold text-gray-900 m-0" data-id="element-176">
                  Abre la microcirculación para que el líquido atrapado salga
                  del cuerpo
                </p>
              </div>
            </div>

            <h4 className="font-bold text-xl mb-4" data-id="element-177">
              Contiene 4 plantas con respaldo científico:
            </h4>
            <ul className="space-y-3 mb-8 text-gray-700" data-id="element-178">
              <li data-id="element-179">
                🌿 <strong data-id="element-180">Amor de Hortelano:</strong> la llamada "escoba
                linfática"
              </li>
              <li data-id="element-181">
                🌿 <strong data-id="element-182">Trébol Rojo:</strong> regula el exceso hormonal
                típico de la menopausia
              </li>
              <li data-id="element-183">
                🌿 <strong data-id="element-184">Raíz de Stillingia:</strong> ataca los bloqueos más
                rebeldes
              </li>
              <li data-id="element-185">
                🌿 <strong data-id="element-186">Corteza de Fresno Espinoso:</strong> reactiva la
                microcirculación
              </li>
            </ul>

            <div className="border-t border-gray-200 pt-8" data-id="element-187">
              <h4 className="font-bold text-xl mb-2 text-[#d4738c]" data-id="element-188">
                Se toma así:
              </h4>
              <p className="text-lg text-gray-800" data-id="element-189">
                ¼ de cucharadita al día disuelta en agua, café o zumo por la
                mañana. Ya está. Cada bote incluye su cucharilla dosificadora.
              </p>
            </div>
          </div>

          {/* Social Proof & Offer */}
          <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-start mt-16" data-id="element-190">
            <figure className="md:w-2/5 w-full flex-shrink-0 m-0" data-id="element-191">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-192">
                <img src="https://cdn.magicpatterns.com/uploads/haRokAUyLBKReqrH9BdNBo/Captura_de_pantalla_2026-04-23_a_las_8.31.52.png" alt="Mujeres usando Drenaje Linfático de Sonvital en su rutina diaria" className="w-full h-auto object-contain" data-id="element-193" />
              </div>
            </figure>
            <div className="flex-1" data-id="element-194">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-0" data-id="element-195">
                Siente El Alivio Del Que Hablan Más De 13.000 Mujeres, Sin
                Riesgo
              </h2>
              <p className="text-lg mb-6" data-id="element-196">
                Más de 13.000 mujeres españolas ya lo han incorporado a su
                rutina diaria para sentirse más ligeras, ver cómo sus tobillos
                vuelven a aparecer, y dejar de esconder sus piernas debajo de
                pantalones largos en pleno agosto.
              </p>
            </div>
          </div>

          <p className="text-center text-gray-600 mt-8 mb-12" data-id="element-197">
            Muchas notan cambios en las primeras 48 horas. Otras en dos semanas.
            Y lo mejor: cada pedido viene con una garantía de devolución de 60
            días. Si no notas la diferencia, devuelves el frasco (aunque esté
            vacío) y te devuelven el dinero. Sin preguntas.
          </p>

          <div className="bg-gray-900 text-white rounded-3xl p-8 md:p-12 text-center shadow-2xl mb-16" data-id="element-198">
            <div className="inline-block bg-red-500 text-white px-4 py-1 rounded-full text-sm font-bold animate-pulse mb-6" data-id="element-199">
              ⚠️ STOCK LIMITADO — Últimos packs disponibles
            </div>

            <div className="mb-8 mx-auto w-64 md:w-72 h-56 md:h-64 rounded-2xl overflow-hidden shadow-lg" data-id="element-200">
              <img src="https://cdn.magicpatterns.com/uploads/jGSKyduy2BiH9vhjqUaGrt/Captura_de_pantalla_2026-04-23_a_las_8.53.21.png" alt="Bote de Drenaje Linfático de Sonvital" className="w-full h-full object-contain" data-id="element-201" />
            </div>

            <div className="space-y-4 mb-8 text-lg" data-id="element-202">
              <div className="flex items-center justify-center gap-3" data-id="element-203">
                <Truck className="text-[#d4738c]" data-id="element-204" />
                <span data-id="element-205">
                  Envío <strong data-id="element-206">GRATIS en 24-48h</strong> en toda España
                </span>
              </div>

              <div className="flex items-center justify-center gap-3" data-id="element-207">
                <CheckCircle className="text-[#d4738c]" data-id="element-208" />
                <span className="text-xl text-yellow-400 font-bold bg-[#00000000]" data-id="element-209">
                  🎁 50% DE DESCUENTO (Oferta Limitada)
                </span>
              </div>
            </div>

            <a href="https://sonvital.com/products/drenaje-linfatico" className="cta-pdp inline-flex items-center justify-center gap-2 bg-[#d4738c] hover:bg-[#b0556d] text-white text-xl md:text-2xl font-bold py-5 px-8 md:px-12 rounded-full shadow-lg transform transition hover:scale-105 w-full md:w-auto no-underline" data-id="element-210">
              Comprobar Disponibilidad <ChevronRight size={28} data-id="element-211" />
            </a>
          </div>
        </article>

        {/* Facebook Comments Section */}
        <section className="mt-16 border-t border-gray-200 pt-8" data-id="element-212">
          <div className="flex items-center gap-2 mb-6 border-b border-gray-200 pb-2" data-id="element-213">
            <MessageCircle className="text-gray-500" data-id="element-214" />
            <h3 className="text-lg font-bold text-gray-900 m-0" data-id="element-215">Comentarios</h3>
          </div>

          <div className="space-y-2" data-id="element-216">
            {commentsData.map(comment => <Comment key={comment.id} comment={comment} data-id="element-217" />)}
          </div>

          <div className="mt-12 text-center" data-id="element-218">
            <a href="https://sonvital.com/products/drenaje-linfatico" className="cta-pdp inline-block bg-[#d4738c] hover:bg-[#b0556d] text-white text-lg font-bold py-4 px-10 rounded-full shadow-md transition-colors no-underline w-full md:w-auto" data-id="element-219">
              👉 Comprobar Disponibilidad — DESCUENTO DEL 50%
            </a>
          </div>
        </section>

        {/* Footer */}
        <footer className="mt-20 pt-10 border-t border-gray-200 text-center text-gray-500 text-sm" data-id="element-220">
          <p className="mb-4" data-id="element-221">
            © 2026 Salud y Bienestar. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6 mb-8" data-id="element-222">
            <a href="#" className="hover:text-gray-900" data-id="element-223">
              Privacidad
            </a>
            <a href="#" className="hover:text-gray-900" data-id="element-224">
              Términos
            </a>
            <a href="#" className="hover:text-gray-900" data-id="element-225">
              Contacto
            </a>
          </div>
          <p className="text-xs text-gray-400 max-w-2xl mx-auto" data-id="element-226">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </footer>
      </main>
    </div>;
}